import { useState, useEffect, useRef } from "react";
import axios from "axios";
import { useHistory } from "react-router-dom";
import FormFooter from "../../general/FormFooter";

const AddUser = ({ check }) => {
    // declaring essentials
    const history = useHistory();
    const ref = useRef();
    const reset = () => {
        ref.current.value = "";
    };
    // declaring state variables
    const [username, setUsername] = useState("");
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [confirmpassword, setConfirmPassword] = useState("");
    const [error, setError] = useState("");
    const [role, setRole] = useState('');
    const [roles, setRoles] = useState([]);
    const [selectedFile, setSelectedFile] = useState('');
    const [loading, setLoading] = useState(true);
    const [message, setMessage] = useState('');

    // general functions
    const timeout = () => {
        setTimeout(() => {
            setError("");
        }, 5000);
    }

    // useEffect function
    const fetchRoles = async () => {
        try {
            const { data } = await axios.get(
                `${process.env.REACT_APP_BACKLINK}/api/private/show-roles`,
                { withCredentials: true }
            );
            setRoles(data.roles)
            setLoading(false)
        } catch (error) {
            setError(error.message)
        }
    };

    useEffect(() => {
        fetchRoles()
    }, []);

    // onsubmit and onchange functions
    const changeHandler = (event) => {
        setSelectedFile(event.target.files[0]);
    };

    const AddUser = async (e) => {
        e.preventDefault();
        if (password !== confirmpassword) {

            setPassword("");
            setConfirmPassword("");
            timeout();
            return setError("Passwords do not match");
        }
        if (role === '') {
            timeout()
            return setError('Role is required')
        }
        const formData = new FormData();
        formData.append("username", username);
        formData.append("email", email);
        formData.append("password", password);
        formData.append("role", role);
        formData.append("profileImage", selectedFile);

        try {
            await axios.post(
                `${process.env.REACT_APP_BACKLINK}/api/private/create-user`,
                formData,
                { withCredentials: true }
            );
            setTimeout(() => {
                setMessage('');
                history.push('/show-users');
            }, 2000);
            setMessage('User Added! Now redirecting you to Users page.')
        }
        catch (err) {
            timeout();
            setError(err.response.msg)
        }
    };

    return (
        <>
            {loading && <h1>Loading...</h1>}

            {!check ? <h1 className="bg-danger">You Dont have Permission for this route. Contact with your admin</h1> : (
                <form onSubmit={AddUser} encType='multipart/form-data' className="row">

                    {error && <div className="bg-danger msgDiv"><p>{error}</p></div>}
                    {message && <div className="bg-success msgDiv"><p>{message}</p></div>}

                    <div className="form-group col-sm-6">
                        <label>*Username:</label>
                        <input type="text" className="form-control"
                            name="username"
                            required={true}
                            value={username}
                            placeholder="Username"
                            onChange={(e) => setUsername(e.target.value)}
                        />
                    </div>
                    <div className="form-group col-sm-6">
                        <label>*Email:</label>
                        <input type="email" name="email" className="form-control"
                            required
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                        />
                    </div>
                    <div className="form-group col-sm-6">
                        <label>*Password:</label>
                        <input type="password" name="password" className="form-control"
                            autoComplete="true"
                            required
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                        />
                    </div>
                    <div className="form-group col-sm-6">
                        <label>*Confirm Password:</label>
                        <input type="password" className="form-control"
                            autoComplete="true"
                            required
                            value={confirmpassword}
                            onChange={(e) => setConfirmPassword(e.target.value)}
                        />
                    </div>
                    <div className="col-sm-6">
                        <label htmlFor="">*Choose Role: </label>
                        <select className="form-control form-select"
                            required={true}
                            name="role"
                            defaultValue='select'
                            onChange={e => setRole(e.target.value)} >
                            <option value='select' disabled>Select Role</option>
                            {roles.map(item => (
                                <option key={item.rolename} name={item.rolename} value={item.rolename}>{item.rolename}</option>
                            ))}
                        </select>
                    </div>
                    <div className="mb-3 col-sm-6">
                        <label htmlFor="formFile" className="form-label">Choose Image: </label>
                        <input
                            className="form-control"
                            type="file"
                            filename="profileImage"
                            ref={ref} id="formFile"
                            onChange={changeHandler} />
                    </div>

                    <FormFooter button="Add User" />
                </form>
            )

            } {/* check end */}

        </>

    ); // return end
};

export default AddUser;